import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import Layout from '../components/Layout'
import { Notebook } from '../components/Notebook';
import { PortableTechnology } from '../components/PortableTechnology';
import { setCodpmpol, setCurrentTab, setErrorEncrypt, setFirstStep, setGlobalTab, setStateNotebook, setTitularData } from '../redux/reducer/stepReducer/stepReducer';
import { createErrorEmail } from '../redux/reducer/stepReducer/thunks';
import { Container } from '@mui/material';

// const PORTABLE_TECNOLOGY = '161'
const PROTECTED_NOTEBOOK = '159'

export const TecnologyData = () => {
    const { firstStep, titularData, codpmpol, protectedNotebook } = useSelector((state) => state.firstStep);
    const dispatch = useDispatch();
    const navigate = useNavigate();

    useEffect(() => {
        if (!codpmpol) {
            try {
                dispatch(setCurrentTab(2));
                dispatch(setGlobalTab(2.6));
                const getLocalStorageCodpmpol = () => { return JSON.parse(localStorage.getItem('codpmpol')) || [] };
                const storageCodpmpol = getLocalStorageCodpmpol();
                if (Array.isArray(storageCodpmpol)) {
                    let message = `Error Recid | TecnologyData | Intencion: ${firstStep.nro} | DNI TITULAR: ${titularData.dni} | NOMBRE TITULAR: ${titularData.name + ' ' + titularData.lastname}`
                    dispatch(createErrorEmail(message));
                    dispatch(setErrorEncrypt(true))
                    navigate('/error');
                } else {
                    dispatch(setCodpmpol(storageCodpmpol));
                    const dataFirstStep = JSON.parse(localStorage.getItem('firstStep'));
                    dispatch(setFirstStep({ ...firstStep, ...dataFirstStep }));
                    const dataTitular = JSON.parse(localStorage.getItem('titularData'));
                    dispatch(setTitularData({ ...titularData, ...dataTitular }));
                    const dataNotebook = JSON.parse(localStorage.getItem('dataNotebook'));
                    dispatch(setStateNotebook({ ...protectedNotebook, ...dataNotebook }));

                };
            } catch (error) {
                let message = `Error Tecnology Data| ${error}`
                dispatch(createErrorEmail(message));
                dispatch(setErrorEncrypt(true))
                navigate('/error');
            }
        }
    }, []);

    return (
        <Layout>
            <Container sx={{ display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
                <div style={{ marginTop: '10px' }}>
                    {
                        firstStep.codsec === PROTECTED_NOTEBOOK ?
                            <Notebook />
                            :
                            // firstStep.codsec === PORTABLE_TECNOLOGY &&
                            <PortableTechnology />
                    }
                </div>
            </Container>
        </Layout >
    )
}
